import React from "react";

interface CalendarIconProps {
  className?: string;
  size?: number;
  color?: string;strokeWidth?: number; strokeWidth2?: number;
}

const CalendarIcon: React.FC<CalendarIconProps> = ({
  size = 19,
  color = '#1E1E1E',
  className,
  strokeWidth = 1.5,
  strokeWidth2 = 2,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.3335 1.58333V3.95833"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6665 1.58333V3.95833"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.771 7.19624H16.2293"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.625 6.72916V13.4583C16.625 15.8333 15.4375 17.4167 12.6667 17.4167H6.33333C3.5625 17.4167 2.375 15.8333 2.375 13.4583V6.72916C2.375 4.35416 3.5625 2.77083 6.33333 2.77083H12.6667C15.4375 2.77083 16.625 4.35416 16.625 6.72916Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4252 10.8458H12.4323"
      stroke={color}
      strokeWidth={strokeWidth2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4252 13.2208H12.4323"
      stroke={color}
      strokeWidth={strokeWidth2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.49647 10.8458H9.50358"
      stroke={color}
      strokeWidth={strokeWidth2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.49647 13.2208H9.50358"
      stroke={color}
      strokeWidth={strokeWidth2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.56629 10.8458H6.5734"
      stroke={color}
      strokeWidth={strokeWidth2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.56629 13.2208H6.5734"
      stroke={color}
      strokeWidth={strokeWidth2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CalendarIcon;
